/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BodyUploadSubmissionFilesApiV2SubmissionsOrgIdFilesUploadPost } from '../../models/body-upload-submission-files-api-v-2-submissions-org-id-files-upload-post';
import { FilesUploaded } from '../../models/files-uploaded';

export interface UploadSubmissionFilesApiV2SubmissionsOrgIdFilesUploadPost$Params {
  id: string;
  org: string;
      body: BodyUploadSubmissionFilesApiV2SubmissionsOrgIdFilesUploadPost
}

export function uploadSubmissionFilesApiV2SubmissionsOrgIdFilesUploadPost(http: HttpClient, rootUrl: string, params: UploadSubmissionFilesApiV2SubmissionsOrgIdFilesUploadPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FilesUploaded>>> {
  const rb = new RequestBuilder(rootUrl, uploadSubmissionFilesApiV2SubmissionsOrgIdFilesUploadPost.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('org', params.org, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FilesUploaded>>;
    })
  );
}

uploadSubmissionFilesApiV2SubmissionsOrgIdFilesUploadPost.PATH = '/api/v2/submissions/{org}/{id}/files/upload';
